import React, { useState } from 'react';
import { Button, Col, Form, Row } from 'antd';
import { FormBox, InputBox } from '../../../../components/AntdAddons';
import { validations } from '../../../../config/validations/validations';
import { EditOutlined } from '@ant-design/icons';
import SVGIcon from '../../../../utils/SVGIcon';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../../store/app';
import {
  fetchInquireNumber,
  updateInquireNumber,
} from '../../../../store/SendMessageSlice';
const AsteriskForm: React.FC<any> = ({ mode }) => {
  const [form] = Form.useForm();
  const dispatch: AppDispatch = useDispatch();

  const [loading, setLoading] = useState<boolean>(false);

  const handleSubmit = (data?: any) => {
    setLoading(true);

    if (mode === 'add') {
      dispatch(fetchInquireNumber(data))
        .then((res: any) => {
          console.log('response add', res);
          // setInquireListData(res?.data);
          // setListData(res?.data);
          // setTotalData(res?.total_data);
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    } else if (mode === 'update') {
      dispatch(updateInquireNumber(data))
        .then((res: any) => {
          console.log('response edit', res);
          // setInquireListData(res?.data);
          // setListData(res?.data);
          // setTotalData(res?.total_data);
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }
  };
  // for validation
  const handleChange = () => {
    form
      .validateFields()
      .then(() => {
        // setDisable(false);
      })
      .catch((error: any) => {
        // setDisable(true);
      });
  };

  return (
    <>
      <FormBox
        className='filterForm'
        form={form}
        onFinish={handleSubmit}
        onChange={handleChange}
        validateTrigger={['onBlur', 'onInput']}
        autoComplete='off'>
        <Row gutter={[20, 0]} align={'bottom'}>
          <Col xs={24} md={12} lg={12} xl={12}>
            <InputBox.Text
              label='Asterisk Number'
              name={'asterisk_number'}
              tooltip='A single number to request to be ported.
              Must be in a domestic form (e.g. 12223555 or *3555)'
              required
              rules={[
                validations.required.text('Asterisk Number'),
                validations.pattern.numericWithSecial,
                // validations.pattern.whitespace,
              ]}
            />
          </Col>
          <Col xs={24} md={12} lg={12} xl={12}>
            <InputBox.Text
              label='Shadow Number'
              name={'shadow_number'}
              tooltip='A single number to request to be ported.
                    Must be in a domestic form (e.g. 12223555 or *3555)'
              required
              rules={[
                validations.required.text('Shadow Number'),
                validations.pattern.numericWithSecial,
                // validations.pattern.whitespace,
              ]}
            />
          </Col>
          <Col xs={12} md={12} lg={6} xl={4}>
            {/* <Form.Item label=' '> */}
            <Button type='primary' htmlType='submit' loading={loading}>
              {mode === 'add' ? (
                <SVGIcon icon='add' color='#fff' width={55} />
              ) : (
                <EditOutlined />
              )}{' '}
              {mode === 'add' ? 'Add' : 'Update'}
            </Button>
            {/* </Form.Item> */}
          </Col>
          <Col xs={12} md={12} lg={6} xl={4}>
            {/* <Form.Item label=' '> */}
            <Button type='default' htmlType='reset'>
              Clear
            </Button>
            {/* </Form.Item> */}
          </Col>
        </Row>
      </FormBox>
    </>
  );
};

export default AsteriskForm;
